import { colorKeys, coreFromSettings, settingsFromCore } from './config';
// A tour's own colors, worn by every page of the tour, the admin wizard included. Null for a tour
// that has not chosen any, which shows in its community's colors.
export const tourThemeOf = (settings) => settings.some(setting => colorKeys.has(setting.key)) ? coreFromSettings(settings) : null;
export const tourThemeSettings = (colors) => settingsFromCore(colors);
